(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["limitless-hiring-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('limitless-hiring-popup')) {
  class LimitlessHiringPopup extends HTMLElement {
    connectedCallback() {
      if (this.controller || window.Shopify?.designMode) return;
      this.dialog = this.querySelector('dialog');
      this.key = 'limitless_hiring_popup_v1';
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      try {
        if (sessionStorage.getItem(this.key) === 'shown') return;
        sessionStorage.setItem(this.key + '_check', '1');
        sessionStorage.removeItem(this.key + '_check');
      } catch { return; }
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-hiring-dismiss]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.querySelector('[data-hiring-apply]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.restore(!this.departing), options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dialog.close(); }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('keydown', event => this.trapFocus(event), options);
      window.addEventListener('pagehide', () => {
        this.departing = true;
        clearInterval(this.timer);
        this.timer = null;
        this.clearSince = null;
        this.gateReadyAt = null;
        if (this.dialog.open) this.dialog.close();
        this.restore(false);
      }, options);
      window.addEventListener('pageshow', () => {
        this.departing = false;
        if (!this.shown && !this.timer) {
          this.timer = setInterval(() => this.check(), 250);
          this.check();
        }
      }, options);
      this.timer = setInterval(() => this.check(), 250);
      this.check();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) this.dialog.close();
      this.restore(false);
    }
    visible(element) {
      if (!element || element.closest('[hidden], [aria-hidden="true"]') || !element.getClientRects().length) return false;
      const style = getComputedStyle(element);
      const box = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && box.bottom > 0 && box.right > 0 && box.top < innerHeight && box.left < innerWidth;
    }
    gateReady() {
      const gate = document.querySelector('limitless-age-gate');
      return (!gate || gate.hasAttribute('data-confirmed')) && !document.documentElement.classList.contains('limitless-age-locked') && !this.visible(document.querySelector('[data-limitless-intro]'));
    }
    blocked() {
      if (document.hidden) return true;
      const active = document.activeElement;
      if (active?.matches('input, textarea, select') || active?.isContentEditable) return true;
      return Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"], joy-loyalty-widget[open], .drawer.active')).some(element => !this.contains(element) && this.visible(element));
    }
    check() {
      if (this.shown || !this.isConnected) return;
      try { if (sessionStorage.getItem(this.key) === 'shown') { clearInterval(this.timer); return; } } catch { clearInterval(this.timer); return; }
      const now = Date.now();
      if (!this.gateReady()) { this.gateReadyAt = null; this.clearSince = null; return; }
      if (this.gateReadyAt == null) this.gateReadyAt = now;
      if (this.blocked()) { this.clearSince = null; return; }
      if (this.clearSince == null) this.clearSince = now;
      if (now - this.gateReadyAt < Number(this.dataset.delay) || now - this.clearSince < 3000) return;
      this.open();
    }
    open() {
      this.previousFocus = document.activeElement;
      this.scrollPosition = { left: window.scrollX, top: window.scrollY };
      this.dialog.hidden = false;
      try { this.dialog.showModal(); } catch { this.dialog.hidden = true; clearInterval(this.timer); return; }
      try { sessionStorage.setItem(this.key, 'shown'); } catch { this.dialog.close(); clearInterval(this.timer); return; }
      this.shown = true;
      clearInterval(this.timer);
      const properties = [[document.documentElement, 'overflow'], [document.body, 'overflow'], [document.body, 'position'], [document.body, 'top'], [document.body, 'width']];
      document.querySelectorAll('.page-wrapper').forEach(element => properties.push([element, 'overflow']));
      this.styles = properties.map(([element, property]) => ({ element, property, value: element.style.getPropertyValue(property), priority: element.style.getPropertyPriority(property) }));
      document.documentElement.style.setProperty('overflow', 'hidden');
      document.body.style.setProperty('overflow', 'hidden');
      document.body.style.setProperty('position', 'fixed');
      document.body.style.setProperty('top', '-' + this.scrollPosition.top + 'px');
      document.body.style.setProperty('width', '100%');
      document.querySelectorAll('.page-wrapper').forEach(element => element.style.setProperty('overflow', 'hidden'));
      this.querySelector('h2').focus({ preventScroll: true });
    }
    restore(restoreFocus = true) {
      if (this.dialog) this.dialog.hidden = true;
      if (!this.styles) return;
      this.styles.forEach(({ element, property, value, priority }) => value ? element.style.setProperty(property, value, priority) : element.style.removeProperty(property));
      this.styles = null;
      window.scrollTo(this.scrollPosition);
      if (restoreFocus && this.previousFocus instanceof HTMLElement && this.previousFocus.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    trapFocus(event) {
      if (event.key !== 'Tab') return;
      const targets = Array.from(this.dialog.querySelectorAll('a[href], button:not([disabled])')).filter(element => this.visible(element));
      const first = targets[0], last = targets[targets.length - 1], active = document.activeElement;
      if (event.shiftKey && (active === first || !targets.includes(active))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (active === last || !targets.includes(active))) { event.preventDefault(); first?.focus(); }
    }
  }
  customElements.define('limitless-hiring-popup', LimitlessHiringPopup);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rewards-welcome"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rewards-welcome')) {
  class RewardsWelcome extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.designMode = this.dataset.designMode === 'true';
      this.customerId = this.dataset.customerId || '';
      this.storagePrefix = `rewards_welcome_v1:${this.dataset.store}:`;
      this.storageKey = `${this.storagePrefix}${this.customerId}`;
      this.attempts = 0;
      this.configureStorefrontSignIn();
      this.querySelectorAll('[data-rw-dismiss]').forEach(button => button.addEventListener('click', () => this.dismiss(), options));
      this.querySelector('[data-rw-preview]')?.addEventListener('click', () => this.open(true), options);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dismiss();
      }, options);
      this.dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { this.departing = true; this.dismiss(); }, options));
      window.addEventListener('pagehide', () => { this.departing = true; this.stop(); this.dismiss(); this.restore(); }, options);
      window.addEventListener('pageshow', event => {
        if (!event.persisted || this.designMode || !this.customerId) return;
        try {
          if (sessionStorage.getItem(`${this.storagePrefix}active`) !== this.customerId || sessionStorage.getItem(this.storageKey) === 'shown') return;
        } catch (error) { return; }
        this.attempts = 0;
        this.schedule(750);
      }, options);
      if (!this.designMode && this.prepareSession()) this.schedule(750);
    }

    disconnectedCallback() {
      this.stop();
      this.departing = true;
      this.dismiss();
      this.restore();
      this.controller?.abort();
      this.controller = null;
    }

    configureStorefrontSignIn() {
      if (this.customerId || this.dataset.routeLogin !== 'true' || !this.dataset.storefrontLoginUrl || !this.dataset.accountLoginUrl) return;
      try {
        const destination = new URL(this.dataset.storefrontLoginUrl, window.location.href);
        if (destination.origin !== window.location.origin) return;
        const accountLogin = new URL(this.dataset.accountLoginUrl, window.location.href);
        const storefrontLogin = destination.pathname + destination.search + destination.hash;
        document.querySelectorAll('a[href]').forEach(link => {
          if (link.closest('form')) return;
          try {
            const current = new URL(link.getAttribute('href'), window.location.href);
            if (current.href !== accountLogin.href) return;
            link.setAttribute('href', storefrontLogin);
          } catch (error) {}
        });
        document.querySelectorAll('shopify-account').forEach(component => {
          const existing = component.getAttribute('sign-in-url');
          if (existing) {
            const configured = new URL(existing, window.location.href);
            if (configured.origin !== destination.origin || configured.pathname !== destination.pathname || configured.search || configured.hash) return;
          }
          component.setAttribute('sign-in-url', storefrontLogin);
        });
      } catch (error) {}
    }

    prepareSession() {
      try {
        const activeKey = `${this.storagePrefix}active`;
        const previousCustomer = sessionStorage.getItem(activeKey);
        if (!this.customerId) {
          if (previousCustomer) sessionStorage.removeItem(`${this.storagePrefix}${previousCustomer}`);
          sessionStorage.removeItem(activeKey);
          return false;
        }
        sessionStorage.setItem(activeKey, this.customerId);
        if (sessionStorage.getItem(activeKey) !== this.customerId) return false;
        return sessionStorage.getItem(this.storageKey) !== 'shown';
      } catch (error) {
        return false;
      }
    }

    visible(element) {
      if (!element || element.closest('[hidden], [aria-hidden="true"]') || !element.getClientRects().length) return false;
      const style = getComputedStyle(element);
      const box = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && box.bottom > 0 && box.right > 0 && box.top < innerHeight && box.left < innerWidth;
    }

    blocked() {
      if (document.visibilityState === 'hidden' || getComputedStyle(document.body).overflowY === 'hidden' || getComputedStyle(document.documentElement).overflowY === 'hidden') return true;
      const candidates = document.querySelectorAll('dialog[open], [role="dialog"], [aria-modal="true"], cart-drawer[open], cart-drawer.active, #CartDrawer.active, .drawer.active, age-verification-pop-up, #cc-intro, #cc-splash-intro, #cc-age-root, [data-limitless-intro], [data-limitless-age-gate]');
      return Array.from(candidates).some(element => element !== this.dialog && !this.contains(element) && this.visible(element));
    }

    schedule(delay) {
      this.stop();
      this.timer = window.setTimeout(() => this.open(false), delay);
    }

    stop() {
      window.clearTimeout(this.timer);
      this.timer = null;
    }

    open(preview) {
      this.stop();
      if (!this.isConnected || this.dialog.open) return;
      if (preview && !this.designMode) return;
      if (!preview && (this.designMode || !this.customerId)) return;
      if (this.blocked()) {
        if (!preview && this.attempts++ < 60) this.schedule(1000);
        return;
      }
      if (!preview) {
        try {
          if (sessionStorage.getItem(this.storageKey) === 'shown') return;
          sessionStorage.setItem(this.storageKey, 'shown');
          if (sessionStorage.getItem(this.storageKey) !== 'shown') return;
        } catch (error) { return; }
      }
      this.lastFocus = document.activeElement;
      this.departing = false;
      this.previousOverflow = document.body.style.getPropertyValue('overflow');
      this.previousOverflowPriority = document.body.style.getPropertyPriority('overflow');
      this.dialog.showModal();
      this.locked = true;
      document.body.style.setProperty('overflow', 'hidden');
      this.querySelector('[data-rw-primary]')?.focus({ preventScroll: true });
    }

    dismiss() {
      this.stop();
      if (this.dialog?.open) this.dialog.close();
    }

    restore() {
      if (this.locked) {
        if (this.previousOverflow) document.body.style.setProperty('overflow', this.previousOverflow, this.previousOverflowPriority);
        else document.body.style.removeProperty('overflow');
        this.locked = false;
      }
      if (!this.departing && this.lastFocus?.isConnected) this.lastFocus.focus({ preventScroll: true });
      this.lastFocus = null;
    }
  }
  customElements.define('rewards-welcome', RewardsWelcome);
}
  } catch(e) { console.error(e); }
})();

})();
